export const qlikClient = {
    SAAS: 'SaaS',
    STANDARD: 'Standard',
};
